import { Cut, formatGrams } from '@onbeefapp/constants';
import cx from 'classnames';
import React from 'react';
import { useDrawerStore } from '../../stores/drawer';
import { getSelectedCutDetail } from '../../utils/CutsUtils';

const DrawerCutOptions: React.FC = () => {
  const {
    isOpen,
    toggleDrawer,
    product,
    key,
    cutTypeID,
    setCutID,
    setDrawerKey,
  } = useDrawerStore((state) => ({
    isOpen: state.isOpen,
    toggleDrawer: state.toggleDrawer,
    product: state.product,
    key: state.key,
    cutTypeID: state.cutTypeID,
    setCutID: state.setCutID,
    setDrawerKey: state.setDrawerKey,
  }));

  const [cuts, setCuts] = React.useState<Cut[]>([]);

  const handleAddCut = (cutID: string) => {
    setCutID(cutID);
    setDrawerKey('drawerGrams');
  };

  React.useEffect(() => {
    setCuts(product.cuts?.filter((cut) => cut.cut_id === cutTypeID) || []);
  }, [product, cutTypeID]);

  const open = (isOpen && key !== 'drawerCutOptions') || !isOpen ? false : true;

  const toggle = () => {
    toggleDrawer('drawerCutOptions');
  };

  return (
    <React.Fragment>
      <div
        className={`z-[9999] fixed inset-0 bottom-0 right-0 p-4 shadow-lg transition-all duration-300 transform
        ${
          open
            ? 'translate-y-0 bg-black-transparent-medium'
            : 'hidden bg-transparent'
        }`}
        onClick={toggle}
      />
      <div
        className={`translate-y-0 fixed z-[9999] bottom-0 right-0 p-4 bg-white shadow-lg w-full rounded-t-2xl transition-all duration-300 transform
        ${open ? 'translate-y-0' : 'translate-y-full'}`}
      >
        <div className="p-4 text-left text-black flex flex-col gap-4">
          <div className="w-full flex flex-col gap-1">
            {cuts && cuts.length > 0 && (
              <article className="font-medium">{cuts[0]!.name}</article>
            )}
            <article className="text-sm font-light">Escolha um tempero</article>
          </div>

          <div className="w-full flex gap-4 flex-wrap max-h-[25rem] overflow-y-auto">
            {cuts.map((cut) => {
              const cutInfo = getSelectedCutDetail(product.id, cut.id);
              const isSelected = cutInfo?.quantity && cutInfo.quantity > 0;

              return (
                <button
                  key={cut.id}
                  className="relative flex flex-col items-center justify-between gap-2 p-4 w-[46%] rounded-lg transition-all duration-200 border-2 border-gray-300 hover:border-gray-400 hover:bg-gray-50"
                  onClick={() => handleAddCut(cut.id)}
                >
                  <span
                    className={cx(
                      'leading-normal text-sm font-medium',
                      isSelected
                        ? 'text-primary font-semibold'
                        : 'text-gray-700',
                    )}
                  >
                    {cut.spice?.name || 'Sem tempero'}
                  </span>

                  {cutInfo?.quantity && (
                    <span
                      className={cx(
                        'leading-normal text-sm font-bold px-2 py-1 rounded-full',
                        isSelected
                          ? 'bg-primary text-white'
                          : 'bg-gray-100 text-gray-800',
                      )}
                    >
                      {formatGrams(cutInfo?.quantity)}
                    </span>
                  )}

                  {!cutInfo?.quantity && (
                    <span className="leading-normal text-xs text-gray-400 font-normal">
                      Clique para adicionar
                    </span>
                  )}
                </button>
              );
            })}
          </div>

          <button
            onClick={toggle}
            className="rounded-full w-full p-2 bg-primary text-contrastText hover:bg-primary/90 transition-colors"
          >
            Fechar
          </button>
        </div>
      </div>
    </React.Fragment>
  );
};

export default DrawerCutOptions;
